import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActividadDto, VwActividad } from '../../shared/interfaces/database/configuracion';

@Injectable({
  providedIn: 'root'
})
export class ActividadService {
  //environment.apiUrl is the base url of the api
  private readonly baseUrl = `${environment.apiUrl}/api/actividad`;

  constructor(private readonly http: HttpClient) { }

  getActividades(): Observable<VwActividad[]> {
    return this.http.get<VwActividad[]>(`${this.baseUrl}`);
  }

  createActividad(request: ActividadDto): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  updateActividad(id:number, request: ActividadDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deleteActividad(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }
}
